<template>
  <section id="skillSummary" class="skill-summary component">
    <h3>Skill Summary</h3>

    <div class="card-deck">

      <!--iteration-->
      <div class="card" v-for="(summary, index) in summaries" :key="index">
        <div class="card-logo">
            <img v-bind:src="publicPath + summary.logo" alt="">
            <h3>{{!!summary.logo ? null : summary.skill}}</h3>
        </div>
        <div class="card-description">
            <p>{{summary.content}}</p>
        </div>
      </div>
    </div>


  </section>
</template>

<script>

  var summaryData = [
      {skill: "Javascript",logo: "logos/JavaScript_logo.svg",content: "Javascript is my first programming language.  I have a fairly deep understanding of the syntax."}
      , {skill: "ReactJS", logo: "logos/react.svg", content: "I've worked on two applications using React Hooks."}
      , {skill: "Node", logo: "logos/node_logo.svg", content: "Using Node 12 to to build AWS Lambda Functions within AWS Lambda."}
      , {skill: "AWS Lambda", logo: "logos/aws_lambda_logo.png", content: "Recently completed AWS Lambda Foundations.  Built a custom application to query the wakatime API and deposit the data to a DynamoDB table."}
      , {skill: "AWS", logo: "aws/cert-images/aws-building-serverless.png", content: "Recently completed the AWS Fundamentals: Building Serverless Applications by Coursera."}
      , {skill: "Vue", logo: "logos/Vue_Logo.svg", content: "Vue is my muse right now. I love it! It has a familiar feel when compared to Knockout and the learning curve appears to be gentle."}
      , {skill: "Java", logo: "logos/Java_logo.svg", content: "I consider myself fluent with Java however that means I only spend 70% of the time googling Classes."}
      , {skill: "Python", logo: "logos/python_logo.svg", content: "I've tinkered with Python while building a remote control car and robotic arm.  I've taken a basic class, but don't use the language often."}
      , {skill: "KnockoutJS", logo: "logos/ko_logo.png", content: "I use knockout extensively in AEM to build applications such as product grids, search and complex carousel information windows."}
      ,{skill: "Adobe Experience Manager", logo: "logos/aem_logo.png", content: "I've spent about four years developing exclusively within AEM and become proficient in building Enterprise-Level websites from the ground up."}

  ];

  export default {
    beforeMount() {},
    methods: {},
    data: function() {
      return {
        publicPath: process.env.BASE_URL,
        summaries: summaryData
      };
    }
  }
</script>

